import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSupabaseClient } from '@supabase/auth-helpers-react';
import './Auth.css';

/**
 * AuthCallback - Handles OAuth redirect and routes user appropriately
 * Uses onAuthStateChange to detect when session is ready (Supabase best practice)
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const supabase = useSupabaseClient();
  const [error, setError] = useState(null);
  const hasRedirected = useRef(false);

  useEffect(() => {
    const checkAndRedirect = async session => {
      if (!session?.user || hasRedirected.current) return;

      hasRedirected.current = true;
      console.log('AuthCallback: Processing session for user:', session.user.id);

      try {
        // Check if user has any projects
        const { data: projects } = await supabase
          .from('join_project_users')
          .select('project_id')
          .eq('user_id', session.user.id)
          .limit(1);

        if (projects?.length > 0) {
          console.log('AuthCallback: Redirecting to /overview');
          navigate('/overview', { replace: true });
        } else {
          console.log('AuthCallback: Redirecting to /wizard');
          navigate('/wizard', { replace: true });
        }
      } catch (err) {
        console.error('Auth callback error:', err);
        setError('שגיאה בטעינת המשתמש');
        setTimeout(() => navigate('/overview', { replace: true }), 2000);
      }
    };

    // Listen for auth state changes (handles OAuth hash automatically)
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event, session) => {
      console.log('AuthCallback: Auth event:', event);
      if (event === 'SIGNED_IN' || event === 'INITIAL_SESSION') {
        checkAndRedirect(session);
      }
    });

    // Also check current session immediately
    supabase.auth.getSession().then(({ data: { session } }) => {
      checkAndRedirect(session);
    });

    return () => subscription.unsubscribe();
  }, [supabase, navigate]);

  return (
    <div className="auth-container login-background">
      <div className="auth-box" style={{ textAlign: 'center' }}>
        {error ? (
          <>
            <div className="error-message">{error}</div>
            <p>מעביר אותך...</p>
          </>
        ) : (
          <>
            <div className="auth-loading-spinner"></div>
            <p style={{ marginTop: '20px', color: '#64748b' }}>מתחבר...</p>
          </>
        )}
      </div>
    </div>
  );
}
